import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import Swal from 'sweetalert2';
import { AccountService } from '../../services/account.service';
import { AccountsService } from '../../services/accounts.service';
import { FunctionService } from '../../services/function.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { UserService } from '../../services/user.service';
import { LOG_LEVELS, LOG_MESSAGES, STATUS_CANCELLED } from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';
declare var $: any;

@Component({
  selector: 'app-function-calendar-dialog',
  templateUrl: './function-calendar.component.html',
  styleUrls: ['./function-calendar.component.css']
})
export class FunctionCalendarDialogComponent implements OnInit, OnDestroy {
  getFunctionListSubscription: Subscription;

  tempDate: any;
  tempMonth: any;
  functionList = [];
  calendarGroup: FormGroup;
  accountData: any;
  eventslist: any;
  resourceId: any;
  numb: any;
  book = new Array();
  tempdata: any = {};
  startDate: any;
  startMonth: any;
  endDate: any;
  endMonth: any;
  startHour: any;
  startMin: any;
  endHour: any;
  endMin: any;
  functionsList: any;
  functionEventsList: any;
  functionsCalendarList: any;
  scheduleAction: any;
  editRoomValue: any;
  calenDarDate: any;
  selectedAccount: any;
  startValue: any;
  endValue: any;
  startTime: any;
  endTime: any;
  getFunctionInfoSubscription: Subscription;
  functionRooms = [];
  roomScheduleId = 0;
  loading = true;

  constructor(
    public dialogRef: MatDialogRef<FunctionCalendarDialogComponent>,
    private functionService: FunctionService,
    private accountService: AccountService,
    private accountsService: AccountsService,
    private formBuilder: FormBuilder,
    private logService: LogService,
    private userService: UserService,
    private ngaugeService: NGaugeService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.loading = true;
    this.buildCalendarGroup();
    this.roomScheduleId = data['roomScheduleId'];
  }

  ngOnDestroy() {
    this.unsubscribe(this.getFunctionInfoSubscription);
    this.unsubscribe(this.getFunctionListSubscription);
    this.tempDate = null;
    this.tempMonth = null;
    this.functionList = null;
    this.calendarGroup = null;
    this.accountData = null;
    this.eventslist = null;
    this.resourceId = null;
    this.numb = null;
    this.book = null;
    this.tempdata = null;
    this.startDate = null;
    this.startMonth = null;
    this.endDate = null;
    this.endMonth = null;
    this.startHour = null;
    this.startMin = null;
    this.endHour = null;
    this.endMin = null;
    this.functionsList = null;
    this.functionEventsList = null;
    this.functionsCalendarList = null;
    this.scheduleAction = null;
    this.editRoomValue = null;
    this.calenDarDate = null;
    this.selectedAccount = null;
    this.startValue = null;
    this.endValue = null;
    this.startTime = null;
    this.endTime = null;
    this.functionRooms = null;
    this.dialogRef = null;
    this.functionService = null;
    this.formBuilder = null;
    this.accountService = null;
    this.userService = null;
    this.ngaugeService = null;
    this.roomScheduleId = null;
    this.data = null;
    this.loading = null;
  }
  unsubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  ngOnInit() {
    const self = this;
    self.loading = true;
    this.scheduleAction = this.functionService.getScheduleRoomAction();
    this.selectedAccount = this.accountService.getAccountDetails();
    this.accountData = this.data.scheduleRoom;
    this.functionEventsList = this.functionService.getListOfEvents();
    this.editRoomValue = this.data.scheduledData;
    this.getFunctionListSubscription = this.functionService.getFunctionRoomsTypes(this.userService.getLoggedInUserProperty()).
      subscribe((data1: any) => {
        const functionRooms = JSON.parse(JSON.stringify(data1));
        const dragText = 'Please Drag to Select Space';
        const findDragBar = functionRooms.find(data => data['name'] === dragText);
        if (!findDragBar) {
          functionRooms.unshift({ 'id': 100, 'name': dragText });
        }
        this.functionRooms = functionRooms;
        const position = 'abcdefghijklmnopqrstuvwxyz';
        this.functionRooms.forEach((datas, index) => {
          datas['id'] = position.charAt(index);
          datas['title'] = datas['name'];
        });
        this.eventslist = this.functionRooms;
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'Function Calendar Dialog Page', 'On Fetch Function rooms', JSON.stringify(error));
      });

    if (DateUtil.getNewDate(this.accountData.value.startDate).getDate() < 10) {
      this.startDate = '0' + DateUtil.getNewDate(this.accountData.value.startDate).getDate();
    } else {
      this.startDate = DateUtil.getNewDate(this.accountData.value.startDate).getDate();
    }

    if (DateUtil.getNewDate(this.accountData.value.startDate).getMonth() + 1 < 10) {
      this.startMonth = '0' + Number(DateUtil.getNewDate(this.accountData.value.startDate).getMonth() + 1);
    } else {
      this.startMonth = DateUtil.getNewDate(this.accountData.value.startDate).getMonth() + 1;
    }

    if (DateUtil.getNewDate(this.accountData.value.endDate).getDate() < 10) {
      this.endDate = '0' + DateUtil.getNewDate(this.accountData.value.endDate).getDate();
    } else {
      this.endDate = DateUtil.getNewDate(this.accountData.value.endDate).getDate();
    }

    if (DateUtil.getNewDate(this.accountData.value.endDate).getMonth() + 1 < 10) {
      this.endMonth = '0' + Number(DateUtil.getNewDate(this.accountData.value.endDate).getMonth() + 1);
    } else {
      this.endMonth = DateUtil.getNewDate(this.accountData.value.endDate).getMonth() + 1;
    }
    this.calendarGroup = this.formBuilder.group({
      functionName: [this.accountData.value.functionName],
      startDate: [DateUtil.getValidTimeZone(this.accountData.value.startDate)],
      startTime: [this.accountData.value.startTime],
      endDate: [DateUtil.getValidTimeZone(this.accountData.value.endDate)],
      endTime: [this.accountData.value.endTime]
    });
    if (this.scheduleAction === 'EditRoomSchedule') {
      self.tempDate = DateUtil.fillZero(DateUtil.getNewDate(self.editRoomValue.startDate).getDate());
      if ((DateUtil.getNewDate(self.editRoomValue.startDate).getMonth() + 1) < 10) {
        self.tempMonth = '0' + (DateUtil.getNewDate(self.editRoomValue.startDate).getMonth() + 1);
      } else {
        self.tempMonth = DateUtil.getNewDate(self.editRoomValue.startDate).getMonth() + 1;
      }
      self.calenDarDate = DateUtil.getNewDate(self.editRoomValue.startDate).getFullYear() + '-' +
        self.tempMonth + '-' + self.tempDate;
    } else {
      const scheduleId = this.functionService.getRoomScheduleId();
      self.tempdata = {
        'id': this.selectedAccount.id,
        'eventresourceId': scheduleId,
        'title': this.accountData.value.eventType,
        'start': DateUtil.getNewDate(this.accountData.value.startDate).getFullYear() + '-' + this.startMonth + '-' + this.startDate + 'T' +
          this.accountData.value.startTime,
        'end': DateUtil.getNewDate(this.accountData.value.endDate).getFullYear() + '-' + this.endMonth + '-' + this.endDate + 'T' +
          this.accountData.value.endTime,
        'resourceIds': '[\'a\']'
      };
      self.accountData.value.startDate = DateUtil.getNewDate(self.accountData.value.startDate);
      self.startValue = DateUtil.getNewDate(this.accountData.value.startDate).getFullYear() + '-' + this.startMonth + '-' + this.startDate;
      self.endValue = DateUtil.getNewDate(this.accountData.value.endDate).getFullYear() + '-' + this.endMonth + '-' + this.endDate;
      self.tempDate = self.accountData.value.startDate.getDate() < 10 ? ('0' + self.accountData.value.startDate.getDate()) :
        self.accountData.value.startDate.getDate();
      self.calenDarDate = self.accountData.value.startDate.getFullYear() + '-' + (this.startMonth) + '-' +
        self.tempDate;
      self.book.push(self.tempdata);
    }
    const userProperty = this.userService.getLoggedInUserProperty();
    this.getFunctionInfoSubscription = this.accountsService.getAllFunctionsInfo(userProperty).subscribe(async data => {
      data['result'] = data['result'].filter(func => func['status'] !== STATUS_CANCELLED);
      this.functionList = data['result'];
      const newFunctions = [];
      for (let i = 0; i < this.functionList.length; i++) {
        const funcRoomSchedule = {};
        funcRoomSchedule['roomSchedule'] = this.functionList[i].roomSchedule;
        funcRoomSchedule['functionName'] = this.functionList[i].functionName;
        this.functionList[i] = funcRoomSchedule;
        this.functionList[i].roomSchedule = this.ngaugeService.isJSON(this.functionList[i].roomSchedule);
        this.functionList[i].roomSchedule = this.functionList[i].roomSchedule.filter(scheduled => scheduled['status'] !== STATUS_CANCELLED);
        for (let j = 0; j < this.functionList[i].roomSchedule.length; j++) {
          const roomFilter = this.eventslist.filter(list => list.name === this.functionList[i].roomSchedule[j].room);
          if (roomFilter[0] !== undefined) {
            roomFilter[0].includerooms = this.ngaugeService.isJSON(roomFilter[0].includerooms);
            for (let m = 0; m < roomFilter[0].includerooms.length; m++) {
              const tempFunctiondata = this.ngaugeService.isJSON(JSON.stringify(this.functionList[i]));
              const sampleFuncRoom = tempFunctiondata.roomSchedule[j];
              sampleFuncRoom.room = roomFilter[0].includerooms[m];
              sampleFuncRoom.status = 'Not Available';
              sampleFuncRoom.roomScheduleId = (i + j + m + this.ngaugeService.getRandomNumber()) * 10;
              tempFunctiondata.roomSchedule = [Object.assign({}, sampleFuncRoom)];
              newFunctions.push(tempFunctiondata);
            }
          } else {
            const tempFunctiondata = this.ngaugeService.isJSON(JSON.stringify(this.functionList[i]));
            const sampleFuncRoom = tempFunctiondata.roomSchedule[j];
            sampleFuncRoom.roomScheduleId = (i + j + this.ngaugeService.getRandomNumber()) * 10;
            tempFunctiondata.roomSchedule = [Object.assign({}, sampleFuncRoom)];
            newFunctions.push(tempFunctiondata);
          }
        }
      }
      this.functionList = this.functionList.concat(newFunctions);
      Loop1: for (const item of this.functionList) {
        for (const schedule of item['roomSchedule']) {
          if (schedule['roomScheduleId'] === this.roomScheduleId) {
            const formValue = this.calendarGroup.value;
            schedule['startDate'] = DateUtil.getDateInMMDDYYYYNew(formValue['startDate']);
            schedule['endDate'] = DateUtil.getDateInMMDDYYYYNew(formValue['endDate']);
            schedule['startTime'] = formValue['startTime'];
            schedule['endTime'] = formValue['endTime'];
            schedule['eventType'] = this.accountData.value.eventType;
            break Loop1;
          }
        }
      }
      const events = await this.functionService.getFunctionDetails(this.functionList, this.functionRooms, false);
      events.forEach(event => {
        self.book.push(event);
      });
      await this.ngaugeService.delay(100);
      $(function () {
        $('#calendar').fullCalendar({
          defaultView: 'timeline',
          defaultDate: self.calenDarDate,
          editable: true,
          contentHeight: 435,
          header: {
            left: 'prev,next',
            right: 'timelineDay,timelineWeek,timelineMonth',
            center: 'title'
          },
          resourceLabelText: 'Rooms',
          events: self.book,
          resources: self.functionRooms,
          eventDrop: function (event, delta, revertFunc, resource) {
            const temp = event.resourceIds.indexOf(event.resourceIds.toString()[event.resourceIds.toString().search(/[a-z]/)]);
            this.resourceId = event.resourceIds[temp];
            self.resource(this.resourceId, event);
          }
        });
        $('#calendar').fullCalendar({
          visibleRange: {
            start: self.startValue,
            end: self.endValue
          }
        });
        self.loading = false;
      });
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'Function Calendar Dialog Page', 'On Fetch Function details', JSON.stringify(error));
    });
  }

  buildCalendarGroup() {
    this.calendarGroup = this.formBuilder.group({
      functionName: [''],
      startDate: [''],
      startTime: [''],
      endDate: [''],
      endTime: ['']
    });
  }

  blockAlpha(event) {
    this.ngaugeService._keyPress(event);
  }

  async resource(id, event) {
    for (const item of this.eventslist) {
      if (item.id === id) {
        const setupInfo = this.ngaugeService.isJSON(item['setupinfo']);
        this.numb = Number(item['squareFeet']);
        if (this.ngaugeService.checkForNllUndef(setupInfo)) {
          const filteredSetup = setupInfo.filter(setup => setup.name === this.accountData.value.setup);
          if (filteredSetup.length > 0) {
            const capacity = this.accountData.value.capacity = filteredSetup[0].capacity !== null &&
              filteredSetup[0].capacity !== undefined ? Number(filteredSetup[0].capacity) : 0;
            if (capacity < this.accountData.value.noOfPeople) {
              const swalObject1 = {
                title: '<strong>Capacity Alert</strong>',
                text: 'Optimal capacity is ' + capacity,
              };
              const contactExists = this.ngaugeService.swalOKButton(swalObject1);
              Swal(contactExists).then(() => { return; });
            }
            this.accountData.value.reqSqFeet = Number(filteredSetup[0]['perPersonArea']) * this.accountData.value.noOfPeople;
          }
        }
        if (this.numb !== null) {
          if (this.accountData.value.reqSqFeet <= this.numb) {
            const capacity = item['capacity'];
            this.accountData.value.capacity = this.ngaugeService.checkForValidity(capacity) ? Number(capacity) : 0;
            if (Number(event.start._i.length) < 12) {
              const getTime = this.functionService.getEventTimes(event.start._i, event.end._i);
              this.startTime = getTime.startTime;
              this.endTime = getTime.endTime;
            }
            if (Number(event.start._i.length) === 16) {
              const startTime = event.start._i.split('T');
              const endTime = event.end._i.split('T');
              this.startTime = startTime[1];
              this.endTime = endTime[1];
            }
            let functionRoomCost = 0;
            const startDate = this.calendarGroup.get('startDate').value;
            const endDate = this.calendarGroup.get('endDate').value;
            functionRoomCost = await this.getfunctionRoomCost(startDate, endDate, item);
            this.functionService.setRoomtype(item.title, this.startTime, this.endTime, this.numb,
              functionRoomCost, this.accountData.value.reqSqFeet, this.accountData.value.capacity);
            this.accountService.setUserRates('rateType');
          } else {
            const swalObject = {
              title: '<strong>Room Sq. Ft. is not large enough</strong>',
              text: 'Missing square feet:' + (this.accountData.value.reqSqFeet - Number(this.numb)),
            };
            const areYouSure = this.ngaugeService.swalOKButton(swalObject);
            Swal(areYouSure);
          }
        } else {
          if (Number(event.start._i.length) < 12) {
            const getTime = this.functionService.getEventTimes(event.start._i, event.end._i);
            this.startTime = getTime.startTime;
            this.endTime = getTime.endTime;
          }
          let functionRoomCost = 0;
          const startDate = this.calendarGroup.get('startDate').value;
          const endDate = this.calendarGroup.get('endDate').value;
          functionRoomCost = <any>await this.getfunctionRoomCost(startDate, endDate, item);
          this.functionService.setRoomtype(item.title, this.startTime, this.endTime, this.numb,
            functionRoomCost, this.accountData.value.reqSqFeet, this.accountData.value.capacity);
          this.accountService.setUserRates('rateType');
        }
      }
    }
  }

  getfunctionRoomCost(startDate, endDate, event): Promise<number> {
    return new Promise(resolve => {
      let functionRoomCost = 0;
      let overAllFunctionRoomCost = 0;
      let noOfDays = Math.round(this.ngaugeService.findCountBetweenDates(startDate, endDate));
      if (noOfDays > 2) {
        const value = event.morethan2 !== undefined ? event.morethan2.split('$')[1] : event.weekDayRent.split('$')[1];
        functionRoomCost = Number(value);
      } else {
        const value = event.weekDayRent.split('$')[1];
        functionRoomCost = Number(value);
      }
      // calculate service Charges
      let tax1Value = 0, tax2Value = 0, tax3Value = 0, tax4Value = 0;
      const serviceCharge = event['serviceCharge'] !== null ? ((functionRoomCost * Number(event['serviceCharge'].split('%')[0])) / 100) : 0;
      if (event['tax1type'] !== null) {
        if (event['tax1type'] === '%') {
          const taxValue = event['tax1'];
          tax1Value = (functionRoomCost * Number(taxValue)) / 100;
        } else if (event['tax1type'] === '$') {
          tax1Value = Number(event['tax1']);
        }
      }
      if (event['tax2type'] !== null) {
        if (event['tax2type'] === '%') {
          const taxValue = event['tax2'];
          tax2Value = (functionRoomCost * Number(taxValue)) / 100;
        } else if (event['tax2type'] === '$') {
          tax2Value = Number(event['tax2']);
        }
      }
      if (event['tax3type'] !== null) {
        if (event['tax3type'] === '%') {
          const taxValue = event['tax3'];
          tax3Value = (functionRoomCost * Number(taxValue)) / 100;
        } else if (event['tax3type'] === '$') {
          tax3Value = Number(event['tax3']);
        }
      }
      if (event['tax4type'] !== null) {
        if (event['tax4type'] === '%') {
          const taxValue = event['tax4'];
          tax4Value = (functionRoomCost * Number(taxValue)) / 100;
        } else if (event['tax4type'] === '$') {
          tax4Value = Number(event['tax4']);
        }
      }
      overAllFunctionRoomCost = functionRoomCost + serviceCharge + tax1Value + tax2Value + tax3Value + tax4Value;
      if (noOfDays === 0) { noOfDays = 1; }
      resolve(Number(overAllFunctionRoomCost) * Number(noOfDays));
    });
  }

  closeFunction(action) {
    this.accountService.setUserRates('scheduleRoomDialog');
    this.dialogRef.close();
    if (action === 'save') {
      this.logService.logUserActivity(LOG_LEVELS.INFO, 'Function Details - Function Calendar', LOG_MESSAGES.SAVE);
    }
    this.logService.logUserActivity(LOG_LEVELS.INFO, 'Function Details - Function Calendar', LOG_MESSAGES.CANCEL);
  }
}



// WEBPACK FOOTER //
// ./src/app/accountFunction/calendar-function/function-calendar-dialog.component.ts